import { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { SetSelectOption, ISelectOption } from "src/@types/form";

interface Props {
  className?: string;
  option: ISelectOption;
  isSelected: boolean;
  onClick: SetSelectOption;
}

export const ButtonSelectorItem: FC<Props> = ({
  className,
  option,
  isSelected,
  onClick,
}) => {
  const { label } = option;

  const { t } = useTranslation();

  const title = typeof label === "string" ? label : t(label.i18nKey);

  const activeVariant = isSelected
    ? ButtonVariants.PRIMARY
    : ButtonVariants.SECONDARY;

  const onClickButton = () => onClick(option);

  return (
    <Button
      className={cn("w-full", className)}
      type="button"
      variant={activeVariant}
      onClick={onClickButton}
    >
      {title}
    </Button>
  );
};
